// extracted by css-extract-rspack-plugin
export default {"Radio":"ReviewMenu-module__Radio__gGWqZ","RadioGroup":"ReviewMenu-module__RadioGroup__jnj83","RadioText":"ReviewMenu-module__RadioText__qkLyB"};